
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SecurityProvider } from "@/components/SecurityProvider";
import LazyTawkToWidget from "@/components/LazyTawkToWidget";
import { isDomain } from "@/hooks/useDomain";
import Index from "./pages/Index";
import BaremetalServers from "./pages/BaremetalServers";
import VPSServers from "./pages/VPSServers";
import ResidentialProxies from "./pages/ResidentialProxies";
import ResidentialRemoteDesktops from "./pages/ResidentialRemoteDesktops";
import ProxyTOS from "./pages/ProxyTOS";
import ServerTOS from "./pages/ServerTOS";
import GeneralTOS from "./pages/GeneralTOS";
import RefundPolicy from "./pages/RefundPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Consultation from "./pages/Consultation";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import DynamicBlogPost from "./pages/DynamicBlogPost";
import NewsHomepage from "./pages/NewsHomepage";
import EthicalProxyArticle from "./pages/EthicalProxyArticle";
import Brokerage from "./pages/Brokerage";
import MobileSolutions from "./pages/MobileSolutions";
import WhyChooseUs from "./pages/WhyChooseUs";
import AshburnInterconnect from "./pages/AshburnInterconnect";
import BangladeshSplash from "./pages/BangladeshSplash";
import TrinidadTobagoSplash from "./pages/TrinidadTobagoSplash";
import IndonesiaSplash from "./pages/IndonesiaSplash";
import NexxInnovate from "./pages/NexxInnovate";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const NewsRoutes = () => (
  <Routes>
    <Route path="/" element={<NewsHomepage />} />
    <Route path="/ethical-proxy-fraud-prevention" element={<EthicalProxyArticle />} />
    <Route path="/:slug" element={<DynamicBlogPost />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

const InnovateRoutes = () => (
  <Routes>
    <Route path="/" element={<NexxInnovate />} />
    <Route path="*" element={<NexxInnovate />} />
  </Routes>
);

const MainRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/baremetal-servers" element={<BaremetalServers />} />
    <Route path="/vps-servers" element={<VPSServers />} />
    <Route path="/residential-proxies" element={<ResidentialProxies />} />
    <Route path="/residential-remote-desktops" element={<ResidentialRemoteDesktops />} />
    <Route path="/mobile-solutions" element={<MobileSolutions />} />
    <Route path="/brokerage" element={<Brokerage />} />
    <Route path="/ashburn-interconnect" element={<AshburnInterconnect />} />
        <Route path="/bangladesh" element={<BangladeshSplash />} />
          <Route path="/trinidad-tobago" element={<TrinidadTobagoSplash />} />
          <Route path="/indonesia" element={<IndonesiaSplash />} />
          <Route path="/nexx-innovate" element={<NexxInnovate />} />
    <Route path="/proxy-tos" element={<ProxyTOS />} />
    <Route path="/server-tos" element={<ServerTOS />} />
    <Route path="/general-tos" element={<GeneralTOS />} />
    <Route path="/refund-policy" element={<RefundPolicy />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/consultation" element={<Consultation />} />
    <Route path="/why-choose-us" element={<WhyChooseUs />} />
    <Route path="/blog" element={<Blog />} />
    <Route path="/blog/:slug" element={<BlogPost />} />
    {/* Dynamic catch-all for potential blog posts */}
    <Route path="/:slug" element={<DynamicBlogPost />} />
    {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

const App = () => {
  const getRoutes = () => {
    if (isDomain('news')) return <NewsRoutes />;
    if (isDomain('innovate')) return <InnovateRoutes />;
    return <MainRoutes />;
  };

  return (
    <QueryClientProvider client={queryClient}>
      <SecurityProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            {getRoutes()}
            <LazyTawkToWidget />
          </BrowserRouter>
        </TooltipProvider>
      </SecurityProvider>
    </QueryClientProvider>
  );
};

export default App;
